<template>
  <div>
    <div class="form-group mb-4">
      <p>
        ¿En el proyecto se utilizarán fuentes radiactivas?
      </p>
      
      <!-- Question 12 -->
      <div class="form-check form-check-inline">
        <input id="question-12-radio-1" :checked="questionnaire.question_12"
               aria-expanded="true" class="form-check-input show-collapse"
               data-target=".question-12-collapse:not(.show)"
               data-toggle="collapse"
               name="question_12"
               type="radio"
               value="1"
               @change="addValidation('question_12')">
        <label class="form-check-label"
               for="question-12-radio-1">Si</label>
      </div>
      
      <div class="form-check form-check-inline">
        <input id="question-12-radio-2" :checked="questionnaire.question_12 === false"
               class="form-check-input"
               data-target=".question-12-collapse.show" data-toggle="collapse"
               name="question_12"
               type="radio"
               value=""
               @change="removeValidation('question_12')">
        <label class="form-check-label"
               for="question-12-radio-2">No</label>
      </div>
      <div data-name="question_12"></div>
    </div>
    
    <div :class="{ 'show': questionnaire.question_12 }" class="question-12-collapse collapse">
      <div class="form-group mb-4">
        <p>
          Seleccione las fuentes radiactivas:
        </p>
        <div class="form-check">
          <input id="radioactive_sources_checkbox_1"
                 v-model="questionnaire.radioactive_sources"
                 class="form-check-input"
                 name="radioactive_sources"
                 type="checkbox"
                 value="Rayos X">
          <label class="form-check-label font-weight-normal"
                 for="radioactive_sources_checkbox_1">
            Rayos X
          </label>
        </div>
        <div class="form-check">
          <input id="radioactive_sources_checkbox_2"
                 v-model="questionnaire.radioactive_sources"
                 class="form-check-input"
                 name="radioactive_sources"
                 type="checkbox"
                 value="Rayos gamma">
          <label class="form-check-label font-weight-normal"
                 for="radioactive_sources_checkbox_2">
            Rayos gamma
          </label>
        </div>
        <div class="form-check">
          <input id="radioactive_sources_checkbox_3"
                 v-model="questionnaire.radioactive_sources"
                 class="form-check-input"
                 name="radioactive_sources"
                 type="checkbox"
                 value="Partículas alfa">
          <label class="form-check-label font-weight-normal"
                 for="radioactive_sources_checkbox_3">
            Partículas alfa
          </label>
        </div>
        <div class="form-check">
          <input id="radioactive_sources_checkbox_4"
                 v-model="questionnaire.radioactive_sources"
                 class="form-check-input"
                 name="radioactive_sources"
                 type="checkbox"
                 value="Partículas beta">
          <label class="form-check-label font-weight-normal"
                 for="radioactive_sources_checkbox_4">
            Partículas beta
          </label>
        </div>
        <div class="form-check">
          <input id="radioactive_sources_checkbox_5"
                 v-model="questionnaire.radioactive_sources"
                 class="form-check-input"
                 name="radioactive_sources"
                 type="checkbox"
                 value="Neutrones">
          <label class="form-check-label font-weight-normal"
                 for="radioactive_sources_checkbox_5">
            Neutrones
          </label>
        </div>
        <div class="form-check">
          <input id="radioactive_sources_checkbox_6"
                 v-model="questionnaire.radioactive_sources"
                 class="form-check-input"
                 name="radioactive_sources"
                 type="checkbox"
                 value="Otro material radioactivo">
          <label class="form-check-label font-weight-normal"
                 for="radioactive_sources_checkbox_6">
            Otro material radioactivo
          </label>
        </div>
        <div data-name="radioactive_sources"></div>
      </div>
      
      <div class="form-group mb-4">
        <label for="radioactive_sources_license">Registro de licencia</label>
        <textarea id="radioactive_sources_license"
                  v-model="questionnaire.radioactive_sources_license"
                  class="form-control"
                  cols="50"
                  name="radioactive_sources_license"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="radioactive_sources_workplace">Lugar de trabajo</label>
        <textarea id="radioactive_sources_workplace"
                  v-model="questionnaire.radioactive_sources_workplace"
                  class="form-control "
                  cols="50"
                  name="radioactive_sources_workplace"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="radioactive_sources_waste_site">Lugar de desecho de los residuos radiactivos</label>
        <textarea id="radioactive_sources_waste_site"
                  v-model="questionnaire.radioactive_sources_waste_site"
                  class="form-control "
                  cols="50"
                  name="radioactive_sources_waste_site"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="radioactive_sources_responsible">Nombre y adscripción del responsable
                                                     con permiso de manejo y el uso del
                                                     isótopo para el proyecto.</label>
        <textarea id="radioactive_sources_responsible"
                  v-model="questionnaire.radioactive_sources_responsible" class="form-control "
                  cols="50"
                  name="radioactive_sources_responsible"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
  import autosize from 'autosize'

  export default {
    name: 'SectionFour',
    props: {
      questionnaire: Object,
    },
    data: () => ({
      fields: {
        question_12: [
          'radioactive_sources_license',
          'radioactive_sources_workplace',
          'radioactive_sources_waste_site',
          'radioactive_sources_responsible',
        ],
      },
    }),
    methods: {
      addValidation (question) {
        const $formBio = $('.biosecurity-form')
        
        this.fields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('add', {
            required: true,
            messages: {
              required: 'Este campo es requerido',
            },
          })
        })
        
        this.questionnaire[question] = true
      },
      removeValidation (question, value = false) {
        const $formBio = $('.biosecurity-form')
        
        this.fields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('remove')
        })
        
        this.questionnaire[question] = value
      },
      setFile (field) {
        this.questionnaire[field] = this.$refs[field].files[0]
      },
    },
    computed: {
      openTabFour() {
        return this.questionnaire.question_4
      }
    },
    watch: {
      openTabFour() {
        if (!this.questionnaire.question_4) {
          for(let field in this.fields) {
            if (this.questionnaire[field] === null) {
              this.questionnaire[field] = null
              this.removeValidation(field, null)
            }
          }
        }
      }
    },
    mounted() {
      const vm = this
  
      autosize($('textarea', this.$el))
      
      $('[name="radioactive_sources"]').rules('add', {
        required: function () {
          return !!vm.questionnaire.question_12
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })
    },
  }
</script>
